import React from 'react';
import { Container, Paper, Typography, Box, Button, Stack } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const ApplyCompletePage = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: 'center',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          {/* アイコン */}
          <CheckCircleOutline
            color="success"
            sx={{ fontSize: 80, mb: 2 }}
          />

          {/* タイトル */}
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            お申し込み完了 🎉
          </Typography>

          {/* 説明 */}
          <Typography variant="body1" color="text.secondary" mb={4}>
            テナント申込とプランの設定が完了しました。<br />
            管理者アカウントでログインして、すぐに利用を開始できます。
          </Typography>

          {/* ボタン */}
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button
              component={RouterLink}
              to={`${process.env.REACT_APP_ADMIN_URL}/login`}
              variant="contained"
              color="primary"
            >
              ログインページへ
            </Button>
            <Button
              component={RouterLink}
              to="/"
              variant="outlined"
              color="secondary"
            >
              トップページへ
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default ApplyCompletePage;
